import React from 'react';
import PropTypes from 'prop-types';
import colors from 'common/styles/colors';
import {
  seedActivityListFilters,
  unreadEventsActivityFilters
} from 'home/Widget/helpers/helpers';
import OrgSegmentedBySiteWidget from './OrgSegmentedBySiteWidget';

const WIDGET_NAME = 'org_unread_unanalysed_by_site';

// Same filter the site-level unread_events widget applies, so the row lands on
// the events it was counting rather than the whole activity list.
const unreadSiteTarget = (accountId) => {
  seedActivityListFilters(accountId, unreadEventsActivityFilters());
  return '/activity';
};

const SEGMENT_KEYS = ['unread_events', 'not_analysed'];

const SEGMENT_COLORS = {
  unread_events: colors.warning,
  not_analysed: colors.critical
};

const SEGMENT_I18N = {
  unread_events: 'orgView.eventsAttention.unread',
  not_analysed: 'orgView.eventsAttention.notAnalysed'
};

const OrgUnreadUnanalysedBySite = props => (
  <OrgSegmentedBySiteWidget
    {...props}
    widgetName={WIDGET_NAME}
    siteLinkTo={unreadSiteTarget}
    emptyMessageKey="orgView.eventsAttention.fetchError"
    emptyMessageDefault="Unable to load event data. Reload after the server is updated."
    noSitesMessageKey="orgView.eventsAttention.noSites"
    noSitesMessageDefault="No sites in this organisation"
    summaryLabelKey="orgView.eventsAttention.orgSummary"
    summaryLabelDefault="Needs attention"
    segmentKeys={SEGMENT_KEYS}
    segmentColors={SEGMENT_COLORS}
    segmentLabelKeys={SEGMENT_I18N}
    getSummaryValue={summary => (summary.total != null ? summary.total : 0)}
    renderSummaryMeta={(t, summary) => t('orgView.eventsAttention.meta', {
      unread: summary.unread_events != null ? summary.unread_events : 0,
      notAnalysed: summary.not_analysed != null ? summary.not_analysed : 0,
      defaultValue: '{{unread}} unread · {{notAnalysed}} not analysed'
    })}
    getSiteRowPrimary={site => (site.total != null ? site.total : 0)}
    compact
    loadingHeight="80px"
    requireSites={false}
  />
);

OrgUnreadUnanalysedBySite.propTypes = {
  organisationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  widgetsMetadata: PropTypes.object,
  title: PropTypes.string
};

OrgUnreadUnanalysedBySite.defaultProps = {
  widgetsMetadata: null,
  title: null
};

export default OrgUnreadUnanalysedBySite;
